import { t } from "i18next";
import { LoadingSpinner } from "../../../general/loading-spinner";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getAthleteAcitivities } from "../../../../services/athlete";
import { Col, Row } from "react-bootstrap";
import moment from 'moment';
import { BarsChart } from "../../../charts/bars-chart";
import { AthleteReportsAcvtivityView } from "./reports-activity-view";

export function AthleteReportsView() {
    const params: any = useParams();

    const [loaded, setLoaded] = useState(false);
    const [reportsData, setReportsData] = useState<any>();
    const [selectedYear, setSelectedYear] = useState(0);
    const [selectedMonth, setSelectedMonth] = useState(0);
    const [selectedMonthName, setSelectedMonthName] = useState('');
    const [selectedDay, setSelectedDay] = useState(0);
    const [avgCategories, setAvgCategories] = useState<string[]>([]);
    const [avgDataBpm, setAvgDataBpm] = useState<number[]>([]);
    const [summaryBpm, setSummaryBpm] = useState(0);
    const [avgDataSpeed, setAvgDataSpeed] = useState<number[]>([]);
    const [summarySpeed, setSummarySpeed] = useState(0);
    const [avgDataDuration, setAvgDataDuration] = useState<number[]>([]);
    const [summaryDuration, setSummaryDuration] = useState(0);
    const [avgDataCalories, setAvgDataCalories] = useState<number[]>([]);
    const [summaryCalories, setSummaryCalories] = useState(0);
    const [activitiesList, setActivitiesList] = useState<any>([]);
    const [selectedActivityId, setSelectedActivityId] = useState('');
    const [showActivityDetails, setShowActivityDetails] = useState(false);
    const [expandedYears, setExpandedYears] = useState<string[]>([]);
    const [expandedMonths, setExpandedMonths] = useState<string[]>([]);

    useEffect(() => {
        const userIds: string[] = [];
        userIds.push(params.id);
        getAthleteAcitivities(userIds)
            .then((response: any) => {
                setReportsData(response.data); 
                setSelectedYear(0);
                setSelectedMonth(0);
                setSelectedMonthName('');
                setSelectedDay(0);
                if (response.data.datesTree.length > 0) {
                    setAvgCategories(response.data.datesTree.map((y: any) => {
                        return y.year;
                    }));
                    setSummaryBpm(response.data.bpm);
                    setAvgDataBpm(response.data.datesTree.map((y: any) =>{
                        return y.bpm.toFixed(2);
                    }));
                    setSummarySpeed(response.data.speed);
                    setAvgDataSpeed(response.data.datesTree.map((y: any) =>{
                        return y.speed;
                    }));
                    setSummaryDuration(response.data.duration);
                    setAvgDataDuration(response.data.datesTree.map((y: any) =>{
                        return y.duration;
                    }));
                    setSummaryCalories(response.data.calories);
                    setAvgDataCalories(response.data.datesTree.map((y: any) =>{
                        return y.calories;
                    }));
                }
                setLoaded(true);
            });
    }, []);

    const handleSelectTreeItem = (event: any) => {
        const year = event.currentTarget.dataset.year;
        setSelectedYear(year);
        const month = event.currentTarget.dataset.month;
        setSelectedMonth(month);
        setSelectedMonthName('');
        const day = event.currentTarget.dataset.day;
        setSelectedDay(day);
        setActivitiesList([]);
        if (year == 0 && month == 0 && day == 0) {
            setSummaryBpm(reportsData.bpm);
            setSummarySpeed(reportsData.speed);
            setSummaryDuration(reportsData.duration);
            setSummaryCalories(reportsData.calories);
            setAvgCategories(reportsData.datesTree.map((y: any) => {
                return y.year;
            }));
            setAvgDataBpm(reportsData.datesTree.map((y: any) =>{
                return y.bpm.toFixed(2);
            }));
            setAvgDataSpeed(reportsData.datesTree.map((y: any) =>{
                return y.speed;
            }));
            setAvgDataDuration(reportsData.datesTree.map((y: any) =>{
                return y.duration;
            }));
            setAvgDataCalories(reportsData.datesTree.map((y: any) =>{
                return y.calories;
            }));
        }
        if (year != 0 && month == 0 && day == 0) {
            const dataTree: any = reportsData.datesTree.filter((yf: any) => yf.year == year)[0];
            setSummaryBpm(dataTree.bpm);
            setSummarySpeed(dataTree.speed);
            setSummaryDuration(dataTree.duration);
            setSummaryCalories(dataTree.calories);
            setAvgCategories(dataTree.months.map((m: any) => {
                return t(m.monthName);
            }));
            setAvgDataBpm(dataTree.months.map((m: any) =>{
                return m.bpm.toFixed(2);
            }));
            setAvgDataSpeed(dataTree.months.map((m: any) =>{
                return m.speed;
            }));
            setAvgDataDuration(dataTree.months.map((m: any) =>{
                return m.duration;
            }));
            setAvgDataCalories(dataTree.months.map((m: any) =>{
                return m.calories;
            }));
        } 
        if (year != 0 && month != 0 && day == 0) {
            const dataTreeYear: any = reportsData.datesTree.filter((yf: any) => yf.year == year)[0];
            const dataTreeMonth: any = dataTreeYear.months.filter((mf: any) => mf.month == month)[0];
            setSelectedMonthName(dataTreeMonth.monthName);
            setSummaryBpm(dataTreeMonth.bpm);
            setSummarySpeed(dataTreeMonth.speed);
            setSummaryDuration(dataTreeMonth.duration);
            setSummaryCalories(dataTreeMonth.calories);
            setAvgCategories(dataTreeMonth.days.map((d: any) => {
                return d.day;
            }));
            setAvgDataBpm(dataTreeMonth.days.map((d: any) =>{
                return d.bpm.toFixed(2);
            }));
            setAvgDataSpeed(dataTreeMonth.days.map((d: any) =>{
                return d.speed;
            }));
            setAvgDataDuration(dataTreeMonth.days.map((d: any) =>{
                return d.duration;
            }));
            setAvgDataCalories(dataTreeMonth.days.map((d: any) =>{
                return d.calories;
            }));
        } 
        if (year != 0 && month != 0 && day != 0) {
            const dataTreeYear: any = reportsData.datesTree.filter((yf: any) => yf.year == year)[0];
            const dataTreeMonth: any = dataTreeYear.months.filter((mf: any) => mf.month == month)[0];
            const dataTreeDay: any = dataTreeMonth.days.filter((df: any) => df.day == day)[0];
            setSummaryBpm(dataTreeDay.bpm);
            setSummarySpeed(dataTreeDay.speed);
            setSummaryDuration(dataTreeDay.duration);
            setSummaryCalories(dataTreeDay.calories);
            setActivitiesList(dataTreeDay.activities);
            setAvgCategories(dataTreeDay.activities.map((a: any) => {
                return a.activityName;
            }));
            setAvgDataBpm(dataTreeDay.activities.map((a: any) =>{
                return a.averageHeartRateInBeatsPerMinute.toFixed(2);
            }));
            setAvgDataSpeed(dataTreeDay.activities.map((a: any) =>{
                return a.averageSpeedInMetersPerSecond;
            }));
            setAvgDataDuration(dataTreeDay.activities.map((a: any) =>{
                return a.durationInSeconds;
            }));
            setAvgDataCalories(dataTreeDay.activities.map((a: any) =>{
                return a.activeKilocalories;
            }));
        } 
    }

    const handleShowActivityDetails = (event: any) => {
        setSelectedActivityId(event.currentTarget.dataset.activityid);
        setShowActivityDetails(true);
    }

    const handleHideActivityDetails = (event: any) => {
        setSelectedActivityId('');
        setShowActivityDetails(false);
    }

    const toggleYear = (year: string) => {
        if (expandedYears.includes(year)) {
            setExpandedYears(expandedYears.filter(y => y !== year));
        } else {
            setExpandedYears([...expandedYears, year]);
        }
    }

    const toggleMonth = (monthKey: string) => {
        if (expandedMonths.includes(monthKey)) {
            setExpandedMonths(expandedMonths.filter(m => m !== monthKey));
        } else {
            setExpandedMonths([...expandedMonths, monthKey]);
        }
    }

    return (
        <div className="reports-container">
            { !loaded && 
                <LoadingSpinner />
            }
            { loaded &&
                <div className="reports-content">
                    <h1>{ t("Your reports") }</h1>
                    <Row>
                        <Col xs={ 12 } lg={ 4 } xl={ 3 }>
                            <div className="timeline">
                                <h2>{ 'Timeline' }</h2>
                                <div className="timeline-items">
                                    <div className={ 'activity-all' + ((selectedYear == 0 && selectedMonth == 0 && selectedDay == 0) ? ' active' : '') } key={ 'a-all' }>
                                        <button className="btn-unformatted" data-year={ 0 } data-month={ 0 } data-day={ 0 } onClick={ handleSelectTreeItem }>
                                            { t("All activities") }
                                        </button>
                                    </div>
                                    { reportsData.datesTree.map((y: any) => {
                                        return <div className={ 'activity-year' + (selectedYear == y.year ? ' active' : '') } key={ 'a-' + y.year }>
                                            <div className="year-header">
                                                <button className="btn-toggle" onClick={() => toggleYear(y.year)}>
                                                    <i className={`bi bi-chevron-${expandedYears.includes(y.year) ? 'down' : 'right'}`}></i>
                                                </button>
                                                <button className="btn-unformatted" data-year={ y.year } data-month={ 0 } data-day={ 0 } onClick={ handleSelectTreeItem }>
                                                    { y.year }
                                                    <span className="item-count">({ y.months.reduce((total: number, m: any) => total + m.days.reduce((dayTotal: number, d: any) => dayTotal + d.activities.length, 0), 0) })</span>
                                                </button>
                                            </div>
                                            { expandedYears.includes(y.year) && <div className="year-months">
                                                { y.months.map((m: any) => {
                                                    const monthKey = y.year + '-' + m.month;
                                                    return (<div className={ 'activity-month' + ((selectedYear == y.year && selectedMonth == m.month) ? ' active' : '') } key={ 'a-' + y.year + m.month }>
                                                        <div className="month-header">
                                                            <button className="btn-toggle" onClick={() => toggleMonth(monthKey)}>
                                                                <i className={`bi bi-chevron-${expandedMonths.includes(monthKey) ? 'down' : 'right'}`}></i>
                                                            </button>
                                                            <button className="btn-unformatted" data-year={ y.year } data-month={ m.month } data-day={ 0 } onClick={ handleSelectTreeItem }>
                                                                { t(m.monthName) }
                                                                <span className="item-count">({ m.days.reduce((dayTotal: number, d: any) => dayTotal + d.activities.length, 0) })</span>
                                                            </button>
                                                        </div>
                                                        { expandedMonths.includes(monthKey) && <div className="month-days">
                                                            { m.days.map((d: any) => {
                                                                return (<div className={ 'activity-day' + ((selectedYear == y.year && selectedMonth == m.month && selectedDay == d.day) ? ' active' : '') } key={ 'a-' + y.year + m.month + d.day }>
                                                                    <button className="btn-unformatted" data-year={ y.year } data-month={ m.month } data-day={ d.day } onClick={ handleSelectTreeItem } title={ d.activities.length + ' ' + t("activities") }>
                                                                        { d.day }
                                                                        <span className="day-count">{ d.activities.length }</span>
                                                                    </button>
                                                                </div>)
                                                            })}
                                                        </div> }
                                                    </div>)
                                                })}
                                            </div> }
                                        </div>;
                                    }) }
                                </div>
                            </div>
                        </Col>    
                        <Col xs={ 12 } lg={ 8 } xl={ 9 }>
                            <div className="report-data-content">
                                <h2>
                                    { t("Aggregated data for") }
                                    { selectedYear == 0 && <strong>&nbsp;{ t("All activities") }</strong> }
                                    { selectedYear != 0 && selectedMonth == 0 && <strong>&nbsp;{ selectedYear }</strong> }
                                    { selectedYear != 0 && selectedMonth != 0 && selectedDay == 0 && <strong>&nbsp;{ t(selectedMonthName) + ' ' + selectedYear }</strong> }
                                    { selectedYear != 0 && selectedMonth != 0 && selectedDay != 0 && <strong>&nbsp;{ selectedDay + '/' + selectedMonth + '/' + selectedYear }</strong> }
                                </h2>
                                <div className="summary">
                                    <div className="totals">
                                        <div className="heartrate activity-kpi">
                                            <div className="value">
                                                { summaryBpm.toFixed(2) } <span className="units">{ t("bpm") }</span>
                                            </div>
                                            <div className="label">
                                                { t("Heart Rate Avg") }
                                            </div>
                                        </div>
                                        <div className="cadence activity-kpi">
                                            <div className="value">
                                                { summarySpeed.toFixed(2) } <span className="units">{ t("m/s") }</span>
                                            </div>
                                            <div className="label">
                                                { t("Speed Avg") }
                                            </div>
                                        </div>
                                        <div className="duration activity-kpi">
                                            <div className="value">
                                                {  moment.utc(summaryDuration*1000).format('HH:mm:ss') }
                                            </div>
                                            <div className="label">
                                                { t("Duration Avg") }
                                            </div>
                                        </div>
                                        <div className="calories activity-kpi">
                                            <div className="value">
                                                { summaryCalories.toFixed(2) } <span className="units">{ t("kcal") }</span>
                                            </div>
                                            <div className="label">
                                                { t("Active Calories Avg") }
                                            </div>
                                        </div>
                                    </div>
                                    { activitiesList.length > 0 && 
                                        <div className="activities-list">
                                            <h4>{ t("Activities list") }</h4>
                                            <ol className="list">
                                                {
                                                    activitiesList.map((a: any) => {
                                                        const activityDate = new Date((a.startTimeInSeconds + a.startTimeOffsetInSeconds)*1000);
                                                        const activityDateFormatted = moment(activityDate).format('DD/MM/Y H:mm')
                                                        return <li className="activity-item" key={ 'activity-item-' + a.activityId }>
                                                                <button className="btn-unformatted" data-activityid={ a.activityId }
                                                                    onClick={ handleShowActivityDetails }>{ activityDateFormatted + ' - ' + a.activityName }</button>
                                                            </li>
                                                    })
                                                }
                                            </ol>
                                        </div>
                                    }
                                </div>
                                { avgCategories.length > 0 && avgDataBpm.length > 0 && 
                                    <BarsChart title={ t("Heart Rate Avg") } 
                                        category={ avgCategories }
                                        data={ avgDataBpm }
                                        units={ t("bpm") }
                                        color={ '#34B689' }
                                        yAxisType="value" />
                                }
                                { avgCategories.length > 0 && avgDataSpeed.length > 0 && 
                                    <BarsChart title={ t("Speed Avg") } 
                                        category={ avgCategories }
                                        data={ avgDataSpeed }
                                        units={ t("m/s") }
                                        color={ '#FABF48' }
                                        yAxisType="value" />
                                }
                                { avgCategories.length > 0 && avgDataDuration.length > 0 && 
                                    <BarsChart title={ t("Duration Avg") } 
                                        category={ avgCategories }
                                        data={ avgDataDuration }
                                        units={ '' }
                                        color={ '#F92C84' }
                                        yAxisType="time" />
                                }
                                { avgCategories.length > 0 && avgDataCalories.length > 0 && 
                                    <BarsChart title={ t("Active Calories") } 
                                        category={ avgCategories }
                                        data={ avgDataCalories }
                                        units={ t("kcal") }
                                        color={ '#009FE3' }
                                        yAxisType="value" />
                                }
                            </div>
                        </Col>                       
                    </Row>
                    { showActivityDetails && selectedActivityId != '' &&
                        <AthleteReportsAcvtivityView userId={ params.id } activityId={ selectedActivityId } onClose={ handleHideActivityDetails } />
                    }
                </div>
            }
        </div>
    );
}